import { render, staticRenderFns } from "./DiagramPort.vue?vue&type=template&id=561efff4&functional=true&"
import script from "./DiagramPort.vue?vue&type=script&lang=js&"
export * from "./DiagramPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561efff4')) {
      api.createRecord('561efff4', component.options)
    } else {
      api.rerender('561efff4', component.options)
    }
    module.hot.accept("./DiagramPort.vue?vue&type=template&id=561efff4&functional=true&", function () {
      api.rerender('561efff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiagramPort.vue"
export default component.exports